import { useState, useEffect, useCallback } from 'react';

export type ThemeId = 'blue' | 'gray' | 'light';

export interface ThemeOption {
  id: ThemeId;
  label: string;
  icon: 'moon' | 'contrast' | 'sun';
}

export const THEMES: ThemeOption[] = [
  { id: 'blue',  label: 'Синяя',   icon: 'moon' },
  { id: 'gray',  label: 'Серая',   icon: 'contrast' },
  { id: 'light', label: 'Светлая', icon: 'sun' },
];

const STORAGE_KEY = 'app-theme';

function readStoredTheme(): ThemeId {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && THEMES.some((t) => t.id === v)) return v as ThemeId;
  } catch { /* SSR / incognito */ }
  return 'blue';
}

export function useTheme() {
  const [theme, setThemeRaw] = useState<ThemeId>(readStoredTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const setTheme = useCallback((id: ThemeId) => setThemeRaw(id), []);

  return { theme, setTheme, themes: THEMES } as const;
}
